import { cn } from "@/lib/utils";

// Estilos compartidos de las vistas del login sobre los primitivos de shadcn (DISENO.md §7.6 y §9):
// campos rellenos de 50 px y botón primario en cápsula del color de acento. Transiciones con nombre,
// con la curva de la app.

const EASE = "ease-[cubic-bezier(0.32,0.72,0,1)]";

/** Campo de 50 px, radio 12 px, relleno gris al 4 %; con error, borde rojo y anillo al 15 %. */
export function loginFieldClasses(hasError: boolean): string {
  return cn(
    "h-[50px] rounded-control border px-4 text-base md:text-base shadow-none",
    "bg-black/[0.04] dark:bg-white/[0.08] placeholder:text-muted-foreground",
    `transition-[background-color,border-color,box-shadow] duration-200 ${EASE}`,
    "focus-visible:bg-card focus-visible:ring-4",
    hasError
      ? "border-destructive ring-4 ring-destructive/15 focus-visible:ring-destructive/15"
      : "border-transparent focus-visible:border-ring focus-visible:ring-ring/20"
  );
}

/** Botón primario: cápsula de 50 px con relleno de acento (texto blanco a 4,7:1). */
export const loginPrimaryButtonClasses = cn(
  "h-[50px] w-full rounded-pill bg-brand-fill text-base font-semibold text-white shadow-none",
  "hover:bg-brand-hover active:scale-[0.98]",
  `transition-[background-color,transform] duration-200 ${EASE}`,
  "focus-visible:ring-4 focus-visible:ring-ring/30 focus-visible:ring-offset-0"
);

/** Acción secundaria de texto ("Volver a iniciar sesión", "Ingresar con RUT y contraseña"). */
export const loginQuietButtonClasses = cn(
  "h-11 rounded-pill px-4 text-sm font-medium text-muted-foreground",
  "hover:bg-black/[0.04] hover:text-foreground dark:hover:bg-white/[0.08]",
  `transition-[background-color,color,transform] duration-200 ${EASE}`,
  "focus-visible:ring-4 focus-visible:ring-ring/30 focus-visible:ring-offset-0"
);

export const loginLabelClasses = "text-[13px] font-medium text-muted-foreground";

export const loginErrorClasses = "text-[13px] leading-[1.4] text-destructive";
